import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

import Settings from "views/Settings";
import Partners from "views/partners";
import EditPartner from "views/partners/EditPartner";
import AddPartner from "views/partners/AddPartner";
import PartnersHeading from "views/partners/Heading";
import ContactUs from "views/ContactUs";

import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";
import AddBlog from "views/blogs/AddBlog";
import ShowBlog from "views/blogs/ShowBlog";
import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";
import Testmonials from "views/testmonials";
import AddTestmonials from "views/testmonials/Add";
import EditTestmonials from "views/testmonials/Edit";
import TestmonialsHeading from "views/testmonials/Heading";
import ContactUsHeading from "views/ContactUs/Heading";
// import BannerContent from "views/blogs/banner";
import SocialTypes from "views/socialTypes";
import AddSocialTypes from "views/socialTypes/AddSocial";
import EditSocialType from "views/socialTypes/EditSocial";

import CompanySummary from "views/about/companySummary";
// import StaticsAboutUs from "views/about/statics";
import ProductsCategories from "views/products/categories";
import Products from "views/products";
import AddProduct from "views/products/Add";
import AddProductsCategory from "views/products/categories/AddCategory";
import EditProductsCategory from "views/products/categories/EditCategory";
import EditProduct from "views/products/Edit";
import ProductsHeading from "views/products/Heading";
import PartnersCompanies from "views/about/partners";
import Vision from "views/about/vision";
import Goals from "views/about/goals";
import Team from "views/about/team";
import Values from "views/about/values";
import SeoServiceSummary from "views/seoServices/seoServiceSummary";
// import StaticsSeoServices from "views/seoServices/statics";
import ProjectsSeoServices from "views/seoServices/projects";
import SeoBeneiftsServices from "views/seoServices/seoBeneifts";
import SeoFutureServices from "views/seoServices/seoFuture";
import SeoTechniques from "views/seoServices/seoTechniques";
import HowWeDoItServices from "views/seoServices/howWeDoIt";
import FaqsServices from "views/seoServices/faqs";
// import StaticsDevelopmentService from "views/developmentService/statics";
import ProjectsDevelopmentService from "views/developmentService/projects";
import SeoBenefitsDevelopmentService from "views/developmentService/seoBeneifts";
import SeoFutureDevelopmentServices from "views/developmentService/seoFuture";
import SeoTechniquesDevelopment from "views/developmentService/seoTechniques";
import HowWeDoItDevelopmentServices from "views/developmentService/howWeDoIt";
import SeoDevelopmentSummary from "views/developmentService/seoDevelopmentSummary";
import CompanySummaryHome from "views/home/companySummary";
import StaticsHome from "views/home/statics";
import ProjectsHome from "views/home/projects";
import SeoBeneiftsHome from "views/home/seoBeneifts";
import SeoFutureHome from "views/home/seoFuture";
import HowWeDoItHome from "views/home/howWeDoIt";
import ServicesHome from "views/home/services";
import Projects from "views/projects";
import AddProjects from "views/projects/Add";
import EditProjects from "views/projects/Edit";
import Service from "views/service";
import AddService from "views/service/Add";
import EditService from "views/service/Edit";
import CompaniesOurServices from "views/ourServicesPage/companies";
import ServicesInOurServices from "views/ourServicesPage/services";
import OurWorksIntro from "views/ourWorks/ourWorksIntro";
import CustomerReviews from "views/customerReviews";
import ContactUsImage from "views/ContactUs/ContactUsImage";
import Welcoming from "views/ourWorks/welcoming";
import ProjectsCategories from "views/projects/categories";
import AddProjectsCategory from "views/projects/categories/AddCategory";
import EditProjectsCategory from "views/projects/categories/EditCategory";
import SeoStoreServiceIntro from "views/seoStoreService/seoStoreServiceIntro";
import WelcomingStoreService from "views/seoStoreService/welcoming";
import SeoBeneiftsSeoStore from "views/seoStoreService/seoBeneifts";

const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}

              <Route
                path="/home/companySummaryHome"
                element={
                  <AuthRoute>
                    <CompanySummaryHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/staticsHome"
                element={
                  <AuthRoute>
                    <StaticsHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/projects"
                element={
                  <AuthRoute>
                    <ProjectsHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/seoBeneiftsHome"
                element={
                  <AuthRoute>
                    <SeoBeneiftsHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/seoFutureHome"
                element={
                  <AuthRoute>
                    <SeoFutureHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/howWeDoIt"
                element={
                  <AuthRoute>
                    <HowWeDoItHome />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/services"
                element={
                  <AuthRoute>
                    <ServicesHome />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/productsHeading"
                element={
                  <AuthRoute>
                    <ProductsHeading />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/home/statics"
                element={
                  <AuthRoute>
                    <Statics />
                  </AuthRoute>
                }
              /> */}

              {/* about  */}
              <Route
                path="/aboutUs"
                element={
                  <AuthRoute>
                    <CompanySummary />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/companySummary"
                element={
                  <AuthRoute>
                    <CompanySummary />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/aboutUs/statics"
                element={
                  <AuthRoute>
                    <StaticsAboutUs />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/aboutUs/partnersCompanies"
                element={
                  <AuthRoute>
                    <PartnersCompanies />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/vision"
                element={
                  <AuthRoute>
                    <Vision />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/values"
                element={
                  <AuthRoute>
                    <Values />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/goals"
                element={
                  <AuthRoute>
                    <Goals />
                  </AuthRoute>
                }
              />
              <Route
                path="/aboutUs/team"
                element={
                  <AuthRoute>
                    <Team />
                  </AuthRoute>
                }
              />

              {/* Our Service */}

              <Route
                path="/ourServices/companiesOurServices"
                element={
                  <AuthRoute>
                    <CompaniesOurServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourServices/services"
                element={
                  <AuthRoute>
                    <ServicesInOurServices />
                  </AuthRoute>
                }
              />
              {/* seoService */}

              <Route
                path="/seoServices/seoServiceSummary"
                element={
                  <AuthRoute>
                    <SeoServiceSummary />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/seoServices/staticsSeoServices"
                element={
                  <AuthRoute>
                    <StaticsSeoServices />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/seoServices/projects"
                element={
                  <AuthRoute>
                    <ProjectsSeoServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoServices/seoBeneifts"
                element={
                  <AuthRoute>
                    <SeoBeneiftsServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoServices/seoFuture"
                element={
                  <AuthRoute>
                    <SeoFutureServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoServices/seoTechniques"
                element={
                  <AuthRoute>
                    <SeoTechniques />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoServices/howWeDoIt"
                element={
                  <AuthRoute>
                    <HowWeDoItServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoServices/faqs"
                element={
                  <AuthRoute>
                    <FaqsServices />
                  </AuthRoute>
                }
              />

              {/* developmentService */}

              <Route
                path="/developmentService/seoDevelopmentSummary"
                element={
                  <AuthRoute>
                    <SeoDevelopmentSummary />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/developmentService/staticsDevelopmentService"
                element={
                  <AuthRoute>
                    <StaticsDevelopmentService />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/developmentService/projects"
                element={
                  <AuthRoute>
                    <ProjectsDevelopmentService />
                  </AuthRoute>
                }
              />
              <Route
                path="/developmentService/seoBenefits"
                element={
                  <AuthRoute>
                    <SeoBenefitsDevelopmentService />
                  </AuthRoute>
                }
              />
              <Route
                path="/developmentService/seoFuture"
                element={
                  <AuthRoute>
                    <SeoFutureDevelopmentServices />
                  </AuthRoute>
                }
              />
              <Route
                path="/developmentService/seoTechniques"
                element={
                  <AuthRoute>
                    <SeoTechniquesDevelopment />
                  </AuthRoute>
                }
              />
              <Route
                path="/developmentService/howWeDoIt"
                element={
                  <AuthRoute>
                    <HowWeDoItDevelopmentServices />
                  </AuthRoute>
                }
              />

              {/* seoStoreService */}
              <Route
                path="/seoStoreService/seoStoreServiceIntro"
                element={
                  <AuthRoute>
                    <SeoStoreServiceIntro />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoStoreService/welcoming"
                element={
                  <AuthRoute>
                    <WelcomingStoreService />
                  </AuthRoute>
                }
              />
              <Route
                path="/seoStoreService/seoBeneiftsSeoStore"
                element={
                  <AuthRoute>
                    <SeoBeneiftsSeoStore />
                  </AuthRoute>
                }
              />
              {/* Projects */}
              <Route
                path="/projects"
                element={
                  <AuthRoute>
                    <Projects />
                  </AuthRoute>
                }
              />
              <Route
                path="/projects/add"
                element={
                  <AuthRoute>
                    <AddProjects />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/:id"
                element={
                  <AuthRoute>
                    <EditProjects />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/projectsCategories"
                element={
                  <AuthRoute>
                    <ProjectsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/projects/projectsCategories/add"
                element={
                  <AuthRoute>
                    <AddProjectsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/projects/projectsCategories/:id"
                element={
                  <AuthRoute>
                    <EditProjectsCategory />
                  </AuthRoute>
                }
              />
              {/* Customer Reviews */}
              <Route
                path="/customerReviews"
                element={
                  <AuthRoute>
                    <CustomerReviews />
                  </AuthRoute>
                }
              />
              {/* Service */}
              <Route
                path="/service"
                element={
                  <AuthRoute>
                    <Service />
                  </AuthRoute>
                }
              />
              <Route
                path="/service/add"
                element={
                  <AuthRoute>
                    <AddService />
                  </AuthRoute>
                }
              />

              <Route
                path="/service/:id"
                element={
                  <AuthRoute>
                    <EditService />
                  </AuthRoute>
                }
              />

              {/* Our Works */}
              <Route
                path="/ourWorks/ourWorksIntro"
                element={
                  <AuthRoute>
                    <OurWorksIntro />
                  </AuthRoute>
                }
              />
              <Route
                path="/ourWorks/welcoming"
                element={
                  <AuthRoute>
                    <Welcoming />
                  </AuthRoute>
                }
              />
              {/* products */}
              <Route
                path="/products"
                element={
                  <AuthRoute>
                    <Products />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/add"
                element={
                  <AuthRoute>
                    <AddProduct />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/:id"
                element={
                  <AuthRoute>
                    <EditProduct />
                  </AuthRoute>
                }
              />

              <Route
                path="/products/productsCategories"
                element={
                  <AuthRoute>
                    <ProductsCategories />
                  </AuthRoute>
                }
              />
              <Route
                path="/products/productsCategories/add"
                element={
                  <AuthRoute>
                    <AddProductsCategory />
                  </AuthRoute>
                }
              />

              <Route
                path="/products/productsCategories/:id"
                element={
                  <AuthRoute>
                    <EditProductsCategory />
                  </AuthRoute>
                }
              />

              {/* testmonials */}
              <Route
                path="/testmonials"
                element={
                  <AuthRoute>
                    <Testmonials />
                  </AuthRoute>
                }
              />
              <Route
                path="/testmonials/add"
                element={
                  <AuthRoute>
                    <AddTestmonials />
                  </AuthRoute>
                }
              />
              <Route
                path="/testmonials/heading"
                element={
                  <AuthRoute>
                    <TestmonialsHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/testmonials/:id"
                element={
                  <AuthRoute>
                    <EditTestmonials />
                  </AuthRoute>
                }
              />

              {/* partners */}
              <Route
                path="/home/partners"
                element={
                  <AuthRoute>
                    <Partners />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/addPartner"
                element={
                  <AuthRoute>
                    <AddPartner />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/heading"
                element={
                  <AuthRoute>
                    <PartnersHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/partners/:id"
                element={
                  <AuthRoute>
                    <EditPartner />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/show/:id"
                element={
                  <AuthRoute>
                    <ShowBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories"
                element={
                  <AuthRoute>
                    <BlogCategories />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/categories/addcategory"
                element={
                  <AuthRoute>
                    <AddBlogCategory />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/categories/:id"
                element={
                  <AuthRoute>
                    <EditBlogCategory />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/blogs/heading"
                element={
                  <AuthRoute>
                    <Heading />
                  </AuthRoute>
                }
              /> */}

              {/* subscribers */}
              {/* <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/profile"
                element={
                  <AuthRoute>
                    <ViewEditProfile />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/contactUs/contactImage"
                element={
                  <AuthRoute>
                    <ContactUsImage />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />
              <Route
                path="/contactUs/heading"
                element={
                  <AuthRoute>
                    <ContactUsHeading />
                  </AuthRoute>
                }
              />

              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />

              {/* socials */}
              <Route
                path="/socials"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              />

              <Route
                path="/socials/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              />
              {/* socialTypes */}
              <Route
                path="/socialTypes"
                element={
                  <AuthRoute>
                    <SocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialTypes />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialTypes/:id"
                element={
                  <AuthRoute>
                    <EditSocialType />
                  </AuthRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
